/**
 * @param {string} text
 * @return {boolean}
 */
export const isMobile = (text) => {
    const pattern = /^1[3-9]\d{9}$/;
    return pattern.test(text);
};
export const isMessageCode = (text) => {
    const pattern = /^[0-9]{4}$/;
    return pattern.test(text);
};
export const isEmail = (text) => {
    const pattern = /^([a-zA-Z0-9]+[_|\\_|\\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\\_|\\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
    return pattern.test(text);
};
/**
 * 验证银行卡
 * @param {string} text 银行卡
 * @return {boolean}
 */
export const isBankCard = (text) => {
    const pattern = /^\d{16,19}$/;
    return pattern.test(text);
};
/**
 * 验证是否为身份证号码
 * @param {string} card 身份证号码
 * @return {boolean}
 */
export const isIdCard = (text) => {
    // 身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X。
    const pattern = /(^\d{15}$)|(^\d{17}([0-9]|X)$)/;
    return pattern.test(text);
};
/* 税号校验，长度15-20，可包含小写和大写字母 */
export const isCompanyNo = (companyNo) => {
    const regex = /^[a-zA-Z0-9]{15,20}$/;
    console.log(companyNo, 'companyNo');
    return regex.test(companyNo);
};
/* export default {
  isMobile,
  isMessageCode,
  isEmail,
  isBankCard,
  isIdCard,
  isCompanyNo
}
 */ 
